import { Loading } from '@components/common/Loading/Loading';
import { lazy } from 'react';
import { RouteObject } from 'react-router';

import { FARMING } from '@/constants/routes';
import { FarmingTable } from '@/pages/Farming/components/FarmingTable/FarmingTable';

const LazyFarming = lazy(() =>
  import('./FarmingPage').then((module) => ({
    default: module.FarmingPage,
  })),
);

const baseRoute: RouteObject = {
  path: FARMING,
  element: <Loading children={<LazyFarming />} />,
  children: [],
};

const farmingRoutes = [
  {
    path: FARMING + '/:indivLocation',
    element: <FarmingTable />,
  },
];
baseRoute.children = [...farmingRoutes];
const routes = baseRoute.children.length > 0 ? [baseRoute] : [];

export const FarmingRoutes = routes;
